import { Box, Heading, Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import Card from '../../components/Card';
import JournalItem from '../../components/Templates/JournalItem';

const JournalTemplates = () => {
  return (
    <VStack px={{ base: 4, md: 10 }} py={8} spacing={{ base: 4, md: 8 }}>
      <Box w={'full'}>
        <Heading>Journal Templates</Heading>
      </Box>
      <Card mx={'auto'} flex={'1'} flexGrow={'1'} h={'full'}>
        <Stack
          w={'full'}
          h={'full'}
          spacing={{ base: 0, xl: 4 }}
          direction={'row'}
          sx={{ h: 'calc(100vh - 260px)' }}
        >
          <JournalItem />
        </Stack>
      </Card>
    </VStack>
  );
};

export default JournalTemplates;
